// core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// services
import { PreRenewalResolver } from '@open-portal-app/core/resolvers/prerenewal.resolver';

// components
import { PreRenewalFlowComponent } from '@open-portal-app/prerenewal/prerenewal-flow/prerenewal-flow.component';

const routes: Routes = [
  { path: ':uuid', component: PreRenewalFlowComponent, pathMatch: 'full', resolve: { step: PreRenewalResolver } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreRenewalRoutingModule { }
